// MF-554 — One look for every Board tile. Starts from the Journal chart theme (Poppins, ink,
// tooltips) and the Student Summary palette, so Boards read like the rest of Maestro.
import { FONT, INK, baseTextStyle, legendBase, tooltipBase } from '../../Journal/Insights/chartTheme'
import { SUMMARY_PALETTE } from '../../Dashboard/StudentSummary/summary.palette'

export { FONT, INK, baseTextStyle, legendBase, tooltipBase, SUMMARY_PALETTE }

// Categorical series colours, in a fixed order (never cycled by rank). The first two are the
// CVD-checked aqua/orange pair used by Journal; identity is never colour-alone (legend + labels).
export const SERIES_COLORS = ['#3a6ea5', '#e08a3c', '#2a9d8f', '#8e6cc9', '#c2527a', '#6b7a8f']

// Colour by MEANING, a closed palette controlled by Maestro (schools do not pick colours): what is
// good / the norm is blue, what needs attention is orange, anything else is grey. An item says which
// is which (a `tone` column); the renderers only look the colour up here.
export const TONE_COLORS = {
  positive: SUMMARY_PALETTE.good,
  negative: SUMMARY_PALETTE.bad,
  neutral: '#98a3b3'
}

// Pill colours for the same three meanings (light fill, dark text): a proficiency level, a band, a grade.
export const TONE_PILL = {
  positive: { bg: '#d3e0f1', fg: '#24407a' },
  negative: { bg: '#f6dcc2', fg: '#7a3e12' },
  neutral: { bg: '#e6e9f0', fg: '#3b4656' }
}

export const TILE = {
  radius: '14px',
  border: SUMMARY_PALETTE.cardBorder,
  pad: 2 // MUI spacing units
}

// Row height of the 12-column grid (plan D7: fixed-height rows). 30px rows give tiles a fine height
// step (a KPI number is 3 rows = 122px); Library item sizes and boards.grid.rowHeight use the same unit.
export const ROW_HEIGHT = 30
export const GRID_GAP = 16

export const fmtValue = (v, decimals = 0) => {
  if (v === null || v === undefined || v === '') return '–'
  const n = Number(v)
  if (!Number.isFinite(n)) return String(v)
  return decimals > 0 ? n.toFixed(decimals) : Math.round(n).toLocaleString()
}

export const fmtAsOf = (iso) => {
  if (!iso) return null
  const d = new Date(iso)
  if (Number.isNaN(d.getTime())) return null
  return d.toLocaleDateString(undefined, { day: 'numeric', month: 'short', year: 'numeric' })
}
